import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';

@Component({
  selector: 'dal-shared-ui-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent implements OnChanges {
  @Input() elements: {
    name: string;
    link: string;
  }[] = [];
  @Input() showSideNav = false;
  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(private route: Router) {}
  ngOnChanges(): void {
    if (this.sidenav !== undefined) {
      this.sidenav?.toggle();
    }
  }

  goto(link: string): void {
    this.route.navigateByUrl(link);
    this.sidenav.close();
  }

  logout(): void {
    // this.oktaAuthService.logout();
  }
}
